module.exports = {
    gitVersion: '62ac099deb90a3c18ae92e978dc27843997728f9',
    appVersion: '25.5.1',
};
